import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { CASH_ENABLED } from "./common/constants";

const CashDashboardPage = lazy(() => import("./pages/CashDashboardPage"));

// DEV-ONLY: el módulo resuelve su propio gate y en producción exporta [].
export const cashRoutes = CASH_ENABLED
  ? [
      { path: "/cash", element: <Navigate to="/cash/dashboard" replace /> },
      { path: "/cash/dashboard", element: <CashDashboardPage /> },
    ]
  : [];

export { CASH_ENABLED } from "./common/constants";
